export const TABLE_FRESH_HOURLY_OOS = "l4_mkt_hourly_oos";
export const TABLE_FRESH_HOURLY_OOS_L7D = "l4_mkt_hourly_oos_l7d";
export const TABLE_FRESH_HOURLY_OOS_L30D = "l4_mkt_hourly_oos_l30d";
export const TABLE_FRESH_HOURLY_OOS_YTD = "l4_mkt_hourly_oos_ytd";